import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppExeDLInfo } from "../../_objects/distributes";
import { ApiService } from "../base/api-base.service";
import { DistributionManagementContractService } from "../interfaces/distribution-management-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { DistributionManagementOfflineService } from "../offline/distribution-management-offline.service";
import { DistributionManagementOnlineService } from "../online/distribution-management-online.service";

@Injectable({
  providedIn: "root"
})
export class DistributionManagementService
  extends ApiService<DistributionManagementContractService>
  implements DistributionManagementContractService
{
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: DistributionManagementOfflineService,
    protected onlineService: DistributionManagementOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // 【DI01】EXEファイル取得
  // GET /api/distribution/exe
  getAppExe(version: string): Observable<AppExeDLInfo> {
    return this.service.getAppExe(version);
  }
}
